// extracted by mini-css-extract-plugin
export default {"container":"mR-z","topReviewHeading":"nR-z","criticalReview":"oR-z","favorableReview":"pR-z","vsSeparator":"qR-z"};